import AdminLayout from "./AdminLayout";
import AdminTable from "./Tables/AdminTable";
import { connect } from 'react-redux';
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import SubLoading from "../../Loading/SubLoading";

const AllAdmins = ({ admins }) => {
    return ( 
        <AdminLayout>
             <div className="row pt-5">
                <div className="col s12 m10 l10 offfset-m1 offset-l1">
                    <h5 className="title is-size-5-touch has-text-weight-semibold mb-2 grey-text text-darken-3">All Admins Acounts</h5>
                    <div className="divider mb-5"></div>
                    {
                        admins ? (
                            <AdminTable admins={admins}/>
                        ) : (
                            <SubLoading />
                        )
                    }
                </div>
            </div>
        </AdminLayout>
     );
}

const mapStateToProps = (state) => {
    //console.log(state);
    return {
        admins: state.firestore.ordered.admins
    };
};
 
export default compose(
    connect(mapStateToProps),
        firestoreConnect((ownProps) => [
            {
                collection: "admins", 
            },
    ])
)(AllAdmins);